<template>
    <div>
        <select
            class="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow focus:outline-none focus:shadow-outline"
            v-model="selectedPickupPoint"
        >
            <option :value="null" disabled selected>
                {{ __('Válassz ki egy budmil üzletet a lenyíló listából!') }}
            </option>

            <optgroup :label="__('Budapesti üzletek')">
                <option v-for="pickupPoint in capitalsPickupPoints"
                        :key="pickupPoint.id"
                        :value="pickupPoint"
                >
                    {{ pickupPoint.name }}
                </option>
            </optgroup>

            <optgroup :label="__('Vidéki üzletek')">
                <option v-for="pickupPoint in isNotCapitalpickupPoints"
                        :key="pickupPoint.id"
                        :value="pickupPoint"
                >
                    {{ pickupPoint.name }}
                </option>
            </optgroup>
        </select>

        <div v-if="selectedPickupPoint"
             class="mt-2"
        >
            <div>
                {{ selectedPickupPoint.zip }} {{ selectedPickupPoint.city }}, {{ selectedPickupPoint.address }}
            </div>

            <div>
                {{ __('Telefonszám') }}: {{ selectedPickupPoint.phone }}
            </div>

            <div class="mt-5">
                {{ __('Nyitva tartás') }}:

                <div v-html="selectedPickupPoint.openingTimes"></div>
            </div>
        </div>

        <form-error
            v-if="errors && Object.keys(errors).length > 0"
            field="pickup_point_id"
            :errors="errors"
        />
    </div>
</template>

<script>
export default {
    name: 'PickupPointStores',
    props: {
        pickupPoints: {
            type: Array,
            required: true
        },
        pickupPoint: {
            type: Number,
            default: null
        },
        errors: {
            type: Object,
            default: null
        },
    },

    data() {
        return {
            selectedPickupPoint: null
        }
    },

    computed: {
        capitalsPickupPoints() {
            return _.filter(this.pickupPoints, ['isCapital', 1])
        },

        isNotCapitalpickupPoints() {
            return _.filter(this.pickupPoints, ['isCapital', 0])
        },
    },

    watch: {
        selectedPickupPoint() {
            this.$emit('input', this.selectedPickupPoint.id)
        },
    },
}
</script>

<style scoped>

</style>
